/** @format */
import { useDispatch } from 'react-redux';

import Store from 'store';
import store from '../store';
import { REGISTER_USER, LOGIN_USER, DUPLICATE_NICKNAME_CHECK, COUNT_BASKET_ITEM } from './types';
import apiClient from '../_utils/axios';

import { getAuth, signInAnonymously } from "firebase/auth";
import { initializeApp } from "@firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyC7Zmuhgz9yHHsC10Q6faHi0ue6AZWXzNI",
  authDomain: "textiledesignbank-354907.firebaseapp.com",
  projectId: "textiledesignbank-354907",
  storageBucket: "textiledesignbank-354907.appspot.com",
  messagingSenderId: "129776358608",
  appId: "1:129776358608:web:5ea391128e2ae6a55b3ad5",
  measurementId: "G-VZX1L89L5S",
  databaseURL: "https://textiledesignbank-354907-default-rtdb.firebaseio.com/"
};

// Initialize Firebase
initializeApp(firebaseConfig);
const auth = getAuth();

const registerUser = async (dataToSubmit) => {
  try {
    const response = await apiClient.post('/users', dataToSubmit);
    console.log('response: ', response);
    if (response) {
  
      return {
        type: LOGIN_USER,
        payload: response.data,
      };
    }
    return {
      type: REGISTER_USER,
      payload: response.data,
    };
  } catch (err) {
    return console.log(err);
  }
};

const sendVerificationEmail = async (email) => {
  try {
    const response = await apiClient.post('/email/verification', {
        email,
        verifyType: '회원가입'
    });
  } catch (err) {
    return console.log(err);
  }
};

const loginUser = async (dataToSubmit) => {
  try {
    const response = await apiClient.post('/login', dataToSubmit);
    console.log('response: ', response);
    if (response.data.message === "Success") {
     
      
      const { accessToken, refreshToken, is_email_verified } = response.data.result.body;
      console.log(response.data.result);
      if (accessToken) {
        Store.set('authdata', 1);
        Store.set('accessToken', accessToken);
        Store.set('refreshToken', refreshToken);
        Store.set('userData', response.data.result.body);
      }

      return {
        type: LOGIN_USER,
        payload: response.data.result.body,
        response: response
      };
    }
    // return {
    //   type: LOGIN_USER,
    //   payload: response.data.result.body,
    //   response: response
    // };
  } catch (err) {
    console.log('err: ', err);
    
    return err;
  }
};

const duplicateNicknameCheck = async (dataToSubmit) => {
  try {
    const response = await apiClient.get('/users/nickname', {
      params: {
        nickname: dataToSubmit,
      },
    })
    return {
      type: DUPLICATE_NICKNAME_CHECK,
      payload: response.data.result,
    };
  } catch (err) {
    return console.log(err);
  }
};

const duplicateEmailCheck = async (dataToSubmit) => {
  try {
    const response = await apiClient.get('/users/email', {
      params: {
        email: dataToSubmit,
      },
    });
    console.log('response: ', response);

    return response;
  } catch (err) {
    return console.log(err);
  }
};

const loginAnonymous = async () => {
  try {
    await signInAnonymously(auth);
  } catch (error) {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.log(`[${errorCode}] : ${errorMessage}`)
  };
}

const countBasketItem = async () => {
  try {
    const res = await apiClient.get('/cart/count');
    return res;
  } catch (error) {
    console.log(error);
    const errorCode = error.code;
    const errorMessage = error.message;
    console.log(`[${errorCode}] : ${errorMessage}`)
  };
}

export { registerUser, loginUser,duplicateEmailCheck, duplicateNicknameCheck, loginAnonymous, countBasketItem, sendVerificationEmail };
